import { ROLES } from "../constants/roles";

import AdminDashboard from "../dashboards/AdminDashboard";
import RemoteWorkerDashboard from "../dashboards/RemoteWorkerDashboard";
import FamilyDashboard from "../dashboards/FamilyDashboard";
import CaregiverDashboard from "../dashboards/CaregiverDashboard";
import ManagementDashboard from "../dashboards/ManagementDashboard";
import ResidentDashboard from "../dashboards/ResidentDashboard";

const DashboardRouter = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) return <p>Not authenticated</p>;

  switch (user.role) {
    case ROLES.ADMIN:
      return <AdminDashboard />;

    case ROLES.REMOTE_WORKER:
      return <RemoteWorkerDashboard />;

    case ROLES.LOCAL_CAREGIVER:
      return <CaregiverDashboard />;

    case ROLES.FAMILY:
      return <FamilyDashboard />;

    case ROLES.MANAGEMENT:
      return <ManagementDashboard />;

    case ROLES.RESIDENT:
      return <ResidentDashboard />;

    default:
      return <p>Unknown role</p>;
  }
};

export default DashboardRouter;
